import { forwardRef, useMemo, RefObject } from 'react';
import cx from 'classnames';

import { BrandLogo, SidebarNav } from '@/components';

import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';
import useDevice from '@/hooks/useDevice';

import styles from './Sidebar.module.sass';

interface SidebarProps {
  isActive?: boolean;
  onClose?: () => void;
  backdropRef?: RefObject<HTMLDivElement>;
}

export const Sidebar = forwardRef<HTMLDivElement | null, SidebarProps>(
  (props, ref) => {
    const { isActive = false, onClose, backdropRef } = props;
    const { isMobile } = useDevice();

    const { data: profileData } = useAppSelector(
      profileSelectors.getProfileSlice,
    );

    const isB2B = useMemo(() => {
      return profileData?.isB2B;
    }, [profileData?.isB2B]);

    const classes = cx(styles.sidebar, {
      [styles['is-active']]: isActive,
    });

    return (
      <>
        {isActive && isMobile && (
          <div
            ref={backdropRef}
            className={styles.backdrop}
            onClick={onClose}
          />
        )}
        <aside className={classes} ref={ref}>
          <BrandLogo className={styles.logo} />

          <SidebarNav isB2B={isB2B} />
        </aside>
      </>
    );
  },
);

export default Sidebar;
